<template lang="pug">
  form(ref="form", @submit.prevent="submit", novalidate)
    app-modal(v-model="value.isOpen", size="xlarge", :type="isCardNotProxing ? 'default' : 'warning'" data-testid="modal-update-card")
      template(slot="title") 名刺情報の変更
      .-layout
        .-layout-left(@scroll="performSticky" style="height:500px")
          .row
            .col-xs-6(ref="stickySibling")
              .row
                .col-xs-6
                  card-field(v-model="data.last_name" :maxlength="maxlengths.last_name")
                .col-xs-6
                  card-field(v-model="data.first_name" :maxlength="maxlengths.first_name")
              .row
                .col-xs-6
                  card-field(v-model="data.last_kana" :maxlength="maxlengths.last_kana")
                .col-xs-6
                  card-field(v-model="data.first_kana" :maxlength="maxlengths.first_kana")
              card-field(v-model="data.corporate_name" :maxlength="maxlengths.corporate_name")
              card-field(v-model="data.corporate_kana" :maxlength="maxlengths.corporate_kana")
              card-field(v-model="data.company_name" :maxlength="maxlengths.company_name")
              card-field(v-model="data.company_kana" :maxlength="maxlengths.company_kana")
              .row
                .col-xs-6
                  card-field(v-model="data.dept" :maxlength="maxlengths.dept")
                .col-xs-6
                  card-field(v-model="data.post" :maxlength="maxlengths.post")
              card-field(v-model="data.dept_post" :maxlength="maxlengths.dept_post")

              br
              card-form-office(office-no="1" v-model="dataO1" :maxlengths="maxlengths")
              br
              card-form-office(office-no="2" v-model="dataO2" :maxlengths="maxlengths")

              .help-block
                p.bcard-required ※ (*)は必須項目です。

            .col-xs-6(ref="stickyElement" class="-sticky-wrap")
              file-droppable(
                v-model="bcard.images",
                :main-image-id="bcard.image_id",
                :multi="true",
                :edit_mode="true",
                :conf_mode="false",
                :view_mode="false"
              )

      template(slot="footer" slot-scope="{close}")
        button.btn.btn-primary(type="submit" data-testid="-btn-edit") 変更
        button.btn.btn-default(type="button", @click="close" data-testid="-btn-cancel") キャンセル
</template>

<script>
import Loading from '@/components/molecules/Loading'
import AppModal from '@/components/templates/AppModal'
// import AppPopup from '@/components/templates/AppPopup'
import FileDroppable from '@/components/organisms/FileDroppable'
import CardField from '@/components/molecules/CardField'
import CardFormOffice from '@/components/organisms/forms/CardFormOffice'
import mixinForm from '@/mixins/form'

import RepositoryFactory from '@/repositories/RepositoryFactory'

const BcardRepository = RepositoryFactory.get('bcard')
const PersonRepository = RepositoryFactory.get('person')

export default {
  name: 'EditCard',
  components: {
    Loading,
    AppModal,
    // AppPopup,
    FileDroppable,
    CardField,
    CardFormOffice
  },
  mixins: [ mixinForm ],
  // mixins: [ autokana ],
  props: {
    /**
     * {Boolean} isOpen
     * {number} sidPerson
     */
    value: { type: Object, required: true },
    mode: {
      type: String,
      required: false,
      default: 'manual',
      validate (value) {
        return this.isIncludes(['manual', 'image'], value)
      }
    },
    isCardNotProxing: { type: Boolean, required: true }
  },
  data () {
    return {
      bcard: {
        // プロパティまでreactiveにするために最初にdefineしておく
        sid_person: '',
        last_name: '',
        first_name: '',
        last_kana: '',
        first_kana: '',
        // full_name: '',
        corporate_name: '',
        corporate_kana: '',
        company_name: '',
        company_kana: '',
        dept: '',
        post: '',
        dept_post: '',
        o1_office_name: '',
        o1_zipcode: '',
        o1_address1: '',
        o1_address2: '',
        o1_tel1: '',
        o1_naisen1: '',
        o1_tel2: '',
        o1_naisen2: '',
        o1_mobile: '',
        o1_fax: '',
        o1_mail: '',
        o1_url: '',
        o2_office_name: '',
        o2_zipcode: '',
        o2_address1: '',
        o2_address2: '',
        o2_tel1: '',
        o2_naisen1: '',
        o2_tel2: '',
        o2_naisen2: '',
        o2_mobile: '',
        o2_fax: '',
        o2_mail: '',
        o2_url: '',
        image_id: '',
        images: []
      },

      maxlengths: {},

      data: {
        last_name: {
          label: '姓',
          field: 'last_name',
          value: '',
          checked: false,
          required: true
        },
        first_name: {
          label: '名',
          field: 'first_name',
          value: '',
          checked: false
        },
        last_kana: {
          label: '姓（よみがな）',
          field: 'last_kana',
          value: '',
          checked: false,
          required: true
        },
        first_kana: {
          label: '名（よみがな）',
          field: 'first_kana',
          value: '',
          checked: false
        },
        corporate_name: {
          label: '会社名',
          field: 'corporate_name',
          value: '',
          checked: false,
          required: true
        },
        corporate_kana: {
          label: '会社名（よみがな）',
          field: 'corporate_kana',
          value: '',
          checked: false,
          required: true
        },
        company_name: {
          label: 'カンパニー名',
          field: 'company_name',
          value: '',
          checked: false
        },
        company_kana: {
          label: 'カンパニー名（よみがな）',
          field: 'company_kana',
          value: '',
          checked: false
        },
        dept: {
          label: '部署名',
          field: 'dept',
          value: '',
          checked: false
        },
        post: {
          label: '役職',
          field: 'post',
          value: '',
          checked: false
        },
        dept_post: {
          label: '部署名＋役職',
          field: 'dept_post',
          value: '',
          checked: false
        }
      },
      dataO1: {
        o1_office_name: {
          label: '事業所名',
          field: 'o1_office_name',
          value: '',
          checked: false
        },
        o1_zipcode: {
          label: '郵便番号',
          field: 'o1_zipcode',
          value: '',
          checked: false
        },
        o1_address1: {
          label: '住所1',
          field: 'o1_address1',
          value: '',
          checked: false
        },
        o1_address2: {
          label: '住所2',
          field: 'o1_address2',
          value: '',
          checked: false
        },
        o1_tel1: {
          label: '電話番号1',
          field: 'o1_tel1',
          value: '',
          checked: false
        },
        o1_naisen1: {
          label: '電話番号1内線',
          field: 'o1_naisen1',
          value: '',
          checked: false
        },
        o1_tel2: {
          label: '電話番号2',
          field: 'o1_tel2',
          value: '',
          checked: false
        },
        o1_naisen2: {
          label: '電話番号2内線',
          field: 'o1_naisen2',
          value: '',
          checked: false
        },
        o1_mobile: {
          label: '携帯電話',
          field: 'o1_mobile',
          value: '',
          checked: false
        },
        o1_fax: {
          label: 'FAX',
          field: 'o1_fax',
          value: '',
          checked: false
        },
        o1_mail: {
          label: 'メールアドレス',
          field: 'o1_mail',
          value: '',
          checked: false
        },
        o1_url: {
          label: 'URL',
          field: 'o1_url',
          value: '',
          checked: false
        }
      },
      dataO2: {
        o2_office_name: {
          label: '事業所名',
          field: 'o2_office_name',
          value: '',
          checked: false
        },
        o2_zipcode: {
          label: '郵便番号',
          field: 'o2_zipcode',
          value: '',
          checked: false
        },
        o2_address1: {
          label: '住所1',
          field: 'o2_address1',
          value: '',
          checked: false
        },
        o2_address2: {
          label: '住所2',
          field: 'o2_address2',
          value: '',
          checked: false
        },
        o2_tel1: {
          label: '電話番号1',
          field: 'o2_tel1',
          value: '',
          checked: false
        },
        o2_naisen1: {
          label: '電話番号1内線',
          field: 'o2_naisen1',
          value: '',
          checked: false
        },
        o2_tel2: {
          label: '電話番号2',
          field: 'o2_tel2',
          value: '',
          checked: false
        },
        o2_naisen2: {
          label: '電話番号2内線',
          field: 'o2_naisen2',
          value: '',
          checked: false
        },
        o2_mobile: {
          label: '携帯電話',
          field: 'o2_mobile',
          value: '',
          checked: false
        },
        o2_fax: {
          label: 'FAX',
          field: 'o2_fax',
          value: '',
          checked: false
        },
        o2_mail: {
          label: 'メールアドレス',
          field: 'o2_mail',
          value: '',
          checked: false
        },
        o2_url: {
          label: 'URL',
          field: 'o2_url',
          value: '',
          checked: false
        }
      }
    }
  },
  watch: {
    'value.isOpen' (isOpen) {
      if (isOpen) {
        this.getData()
      }
    }
  },
  created () {
    this.maxlengths = this.loadMaxlengths('Bcards')

    if (this.value.isOpen) {
      this.getData()
    }
  },
  methods: {
    performSticky (e) {
      const stickyElement = this.$refs.stickyElement.firstChild
      const stickySibling = this.$refs.stickySibling
      stickyElement.style.top = Math.min(
        stickySibling.offsetHeight - stickyElement.offsetHeight,
        e.target.scrollTop
      ) + 'px'
    },
    getData () {
      const vm = this
      PersonRepository.getLatestBcard(this.value.sidPerson, this.isMgmt)
        .then(function (response) {
          const data = vm.getApiData(response).data
          vm.bcard = data

          for (let field in vm.data) {
            vm.data[field].value = data[field]
          }

          for (let field in vm.dataO1) {
            vm.dataO1[field].value = data[field]
          }

          for (let field in vm.dataO2) {
            vm.dataO2[field].value = data[field]
          }
        })
        .catch(function (error) {
          const message = vm.getErrorMessage(error)
          if (message) {
            vm.showToast(message, { type: 'danger' })
          }
        })
    },
    close () {
      const value = this.value
      value.isOpen = false
      this.$emit('input', value)
    },
    submit () {
      const form = this.$refs.form

      // チェック対象とするダイアログの設定
      // this.setDialogForm(form)
      if (!this.checkFormValidity(this.$refs.scrollWrap)) {
        this.showToast('入力内容をもう一度確認してください。', { type: 'danger' })
        return
      }

      const vm = this

      // 登録内容
      let formData = new FormData(form)

      // FileListからFileを削除するための苦肉の策
      formData = this.appendFiles(formData)

      BcardRepository.put(this.bcard.id, formData, this.isMgmt)
        .then(function (response) {
          vm.close()
          vm.showToast('名刺情報を変更しました。', { type: 'success' })
          // 一覧更新
          vm.$store.dispatch('reloadBcardList')
          // サイドメニューの件数更新
          vm.$store.dispatch('reloadSidemenu')
        })
        .catch(function (error) {
          const message = vm.getErrorMessage(error) || '名刺情報を変更できませんでした。'
          vm.showToast(message, { type: 'danger' })
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.-sticky-wrap {
  position: relative;
  .bcard-file {
    width: calc(100% - 15px);
    position: absolute;
    top: 0;
    left: 0;
    /*z-index: 1000; !* date-pickerが900なので *!*/
  }
}

/*
  TODO max-height scroll
  TODO 右サイドにスクロールが出た場合の固定
 */
.candidates {
  position: absolute;
  bottom: 0;
  right: 15px;
  width: calc(25% - 30px);
  margin-bottom: 0;

  .list-group {
    margin: -10px;

    .list-group-item {
      border-left: 0;
      border-right: 0;
      border-bottom: 0;

      &:first-child {
        border-top: 0;
      }
    }
  }
}
.-layout .-layout-right {
  /* 候補を出すための余白 */
  padding-bottom: 4em;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/box/EditCard.vue